import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, ListItem, fade, useTheme } from '@material-ui/core';
import { RouteIcon } from '../ui-kit';
import { StyledListItemIcon, StyledListItemText } from './style';
import { ListItemLinkProps } from './types';

const ListItemLink = ({ icon, active, primary, to, onClick, trailingIcon, isNested, isCollapsible }: ListItemLinkProps) => {
    const theme = useTheme();

    const TrailingIcon = trailingIcon;
    const paddingLeft = isNested ? theme.spacing(2) : 0;
    const backgroundColor = active ? fade(theme.palette.primary.main, 0.16) : undefined;

    return (
        <ListItem
            style={{ paddingLeft, backgroundColor }}
            disableGutters
            onClick={onClick}
            button
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            component={!isCollapsible && to ? RouterLink : undefined as any}
            to={!isCollapsible ? to : undefined}
            selected={false}
        >
            {icon
                ? (
                    <StyledListItemIcon isActive={active}>
                        <RouteIcon isMatch={active} icon={icon} />
                    </StyledListItemIcon>
                )
                : <Box style={{ width: `${theme.appDrawer.collapsedWidth as number - theme.spacing(2)}px` }} />}
            <StyledListItemText primaryTypographyProps={{ variant: icon ? 'body1' : 'body2' }} primary={primary} />
            {TrailingIcon
            ? (
                <>
                    <TrailingIcon />
                    <Box pr={2} />
                </>
            ): null}
        </ListItem>
    );
};

export default ListItemLink;
